import RiskAssessmentModel  from 'Models/intervention/RiskAssessmentModel';
import TaskZoneModel        from 'Models/intervention/TaskZoneModel';
import SourceModel          from 'Models/invoice/SourceModel';
import VatModel             from 'Models/invoice/VatModel';
import ActivityModel        from 'Models/sales/ActivityModel';
import QuotationItemModel   from 'Models/sales/QuotationItemModel';
import doc                  from 'decorators/doc';
import model                from 'decorators/model';
import { Timestampable }    from 'helpers/traits';
import { Blamable }         from 'helpers/traits';
import SalesPrivateApiModel from 'modelx/models/abstracts/SalesPrivateApiModel';

@model.staticLabel('Ligne de prestation', false)
@model.urnResource('quotation_item_activity')
@doc.path('/quotation_item_activities/{?id}')
export default class QuotationItemActivityModel extends Blamable(Timestampable(SalesPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'exists[itemActivityArticles]': '0' | '1';
		'locationUrn': Urn;
		'quotationItem': id;
		'quotationItem.quotation': id;
		'sourceUrn': Urn;
		'tags[serviceUrn][tagReference]': id;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'position': string;
		'quotationItem.position': string;
	}> = {};

	@doc.model(ActivityModel) declare activity: ActivityModel;
	@doc.string declare label: string;
	@doc.number declare labourHourlyCost: number;
	@doc.string declare note: string;
	@doc.number declare position: number;
	@doc.number declare priceExclTax: number;
	@doc.string declare quantity: string;
	@doc.model(QuotationItemModel) declare quotationItem: QuotationItemModel;
	@doc.modelUrn(RiskAssessmentModel) declare riskAssessment: RiskAssessmentModel;
	@doc.number declare rawTotalPriceExclTax: number;
	@doc.modelUrn(SourceModel) declare source: SourceModel;
	@doc.number declare totalArticleCost: number;
	@doc.number declare totalArticleMargin: number;
	@doc.number declare totalArticlePrice: number;
	@doc.number declare totalLabourPrice: number;
	@doc.number declare totalPriceExclTax: number;
	@doc.number declare totalPriceInclTax: number;
	@doc.string declare vatRate: string;
	@doc.modelUrn(VatModel) declare vat: VatModel;

	@model.resolvable(TaskZoneModel, { attributeName: 'locationUrn' })
	declare location: TaskZoneModel;

	get item() {
		return this.quotationItem;
	}

	get isAcc() {
		return this.quotationItem.quotation.activityCategory.reference === 'acc';
	}

	get status() {
		return this.quotationItem.quotation.quotationStatus;
	}

	get vatUrn() {
		return this.get('vat.@urn');
	}
}